import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="bg-shell min-h-screen flex items-center justify-center text-[color:var(--muted)] text-xs tracking-[0.3em] uppercase" data-testid="auth-loading">
        Checking session…
      </div>
    );
  }
  if (!user) {
    return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  }
  if (adminOnly && !user.is_admin) {
    return (
      <div className="bg-shell min-h-screen flex items-center justify-center px-6" data-testid="forbidden-page">
        <div className="text-center max-w-md">
          <div className="text-[10px] tracking-[0.3em] uppercase text-[color:var(--red)] mb-3">403 · Forbidden</div>
          <h1 className="font-display italic text-4xl text-[color:var(--ink)] mb-3">Admin only.</h1>
          <p className="text-sm text-[color:var(--muted)]">This page is for admins. Your account doesn't have those permissions.</p>
        </div>
      </div>
    );
  }
  return children;
}
